module.exports = __webpack_public_path__ + "media/images/lp/industries/realestate/kachial-8e700253b48e6ec3a9df86e624d7481a.png";